import {
  ICity,
  ICityData,
  Country,
  ICountry,
  CITY_NAME_MAX_LENGTH
} from './index'

export class City implements ICity {
  readonly id?: number
  name: string
  country?: ICountry

  constructor(data?: ICityData) {
    this.id = data?.id
    this.name = data?.name || ''
    let country = data?.country
    this.country = country ? new Country(country) : undefined
  }

  validate(): boolean {
    return this.validateName()
  }

  validateName(): boolean {
    let name = this.name
    return !!name && name.length <= CITY_NAME_MAX_LENGTH
  }

  update(data?: ICityData): void {
    this.name = data?.name || this.name
    let country = data?.country
    if (country) {
      this.country?.update(country)
    }
  }

  get path(): string {
    let country = this.country
    return this.name + (country ? (', ' + country.name) : '')
  }

}